import { env } from "@/env";

export const isExternalLink = (href: string): boolean => {
  return (
    (href.startsWith("http://") || href.startsWith("https://")) &&
    !href.includes(env.NEXT_PUBLIC_APP_BASE_URL)
  );
};
